import React, { Fragment, useState, useRef, useEffect } from 'react'
import { Col, Card, Row, Input, CardBody, Button, CardHeader, FormGroup, Label } from 'reactstrap';
import { useReportLogs } from '../../../hooks/Pbi/useReportLogs';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Steps } from 'primereact/steps';
import { Badge } from 'primereact/badge';
import { Tag } from 'primereact/tag';


export const IndexReportLogs = () => {

    const { dataReport, handleReport, nim, handleInputChange, dataPatient, loadingReport, dataTraceability, expandedRows, setExpandedRows, containerStyle, activeIndex, setActiveIndex, exportToExcelConTrazabilidad, loadingExcel, enable_tracking_toma
    } = useReportLogs();


    const rowExpansionTemplate = (rowData) => {
        console.log("🚀 ~ rowExpansionTemplate ~ rowData:", rowData)
        if (rowData.type === "profile") {
            return (
                <div style={containerStyle} className='table-responsive' >
                    <DataTable
                        stripedRows
                        value={rowData.listExm}
                        className="data-table"
                        emptyMessage={
                            <div className="text-center">
                                <img
                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                    style={{ width: "60%" }}
                                    alt="Sin resultados"
                                />
                                <br />
                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                                    No hay detalles de perfil disponibles
                                </p>
                            </div>
                        }
                        style={{ fontSize: "12px", width: '100%' }}
                        scrollable
                        scrollWidth="100%"
                    >
                        <Column field="name" header="Estudio" headerStyle={{
                            backgroundColor: "#1d5b83",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "4px",
                        }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }} />
                        <Column field="is_toma" header="Toma de muestra" body={(rowData) => (rowData.type === 'profile' ? "" : (rowData.is_toma ? <i className='fa fa-check txt-success f-18' ></i> : rowData.check_forwarded ? "Remitida" : <i className='fa fa-times text-danger f-16' ></i>))} headerStyle={{
                            backgroundColor: "#94bcd5",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "4px",
                        }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }} />
                        <Column field="init_time" header="Fecha Inicio" body={row => row.traceabilitSampling && row.traceabilitSampling.length > 0 ? row.traceabilitSampling[0].init_time : row.check_forwarded ? "N/A" : "Sin Fecha"} headerStyle={{
                            backgroundColor: "#94bcd5",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "4px",
                        }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }} />
                        <Column field="flebo" header="Usuario" body={row => row.traceabilitSampling && row.traceabilitSampling.length > 0 ? row.traceabilitSampling[0].flebo : row.check_forwarded ? "N/A" : "Sin Usuario"} headerStyle={{
                            backgroundColor: "#94bcd5",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "4px",
                        }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }} />
                        <Column field="is_send1" header="Envío" body={(rowData) => (rowData.type === 'profile' ? "" : (rowData.is_send1 ? <i className='fa fa-check txt-success f-18' ></i> : <i className='fa fa-times text-danger f-16' ></i>))} headerStyle={{
                            backgroundColor: "#0079c7",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "4px",
                        }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }} />
                        <Column field="init_time_procces2"
                            header="Fecha Envio"
                            body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                                ? row.traceabilitSend[row.traceabilitSend.length - 1].init_time_procces2
                                : "Sin Fecha"}
                            headerStyle={{
                                backgroundColor: "#0079c7",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "10px",
                                padding: "4px",
                            }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }}
                        />
                        <Column field="user_process2"
                            header="Usuario de Envio"
                            body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                                ? row.traceabilitSend[row.traceabilitSend.length - 1].user_process2
                                : "Sin Usuario"}
                            headerStyle={{
                                backgroundColor: "#0079c7",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "10px",
                                padding: "4px",
                            }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }}
                        />
                        <Column field="is_send2" header="Recepción" body={(rowData) => (rowData.type === 'profile' ? "" : (rowData.is_send2 ? <i className='fa fa-check txt-success f-18' ></i> : <i className='fa fa-times text-danger f-16' ></i>))} headerStyle={{
                            backgroundColor: "#46afe5d4",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "4px",
                        }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }} />
                        <Column
                            field="init_time_procces3"
                            header="Fecha Recepción"
                            body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                                ? row.traceabilitSend[row.traceabilitSend.length - 1].init_time_procces3
                                : "Sin Fecha"}
                            headerStyle={{
                                backgroundColor: "#46afe5d4",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "10px",
                                padding: "4px",
                            }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }}
                        />
                        <Column field="user_process3"
                            header="Usuario Recepción"
                            body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                                ? row.traceabilitSend[row.traceabilitSend.length - 1].user_process3
                                : "Sin Usuario"}
                            headerStyle={{
                                backgroundColor: "#46afe5d4",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "10px",
                                padding: "4px",
                            }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }}
                        />
                    </DataTable>
                </div>
            );
        }

        if (rowData.is_curve && rowData.arrayCurves?.length > 0) {
            return (
                <div style={{ padding: "0rem" }}>
                    {/* <strong>{rowData.name} </strong> */}
                    <table style={{ width: "100%", fontSize: "10px", borderCollapse: "collapse", marginTop: "4px" }}>
                        <thead>
                            <tr style={{ textAlign: "center" }}>
                                <th style={{ border: "1px solid #ccc", padding: "2px", backgroundColor: "#1d5b83", color: "#fff" }}>N° Toma</th>
                                <th style={{ border: "1px solid #ccc", padding: "2px", backgroundColor: "#94bcd5", color: "#fff" }}>Toma de muestra</th>
                                <th style={{ border: "1px solid #ccc", padding: "2px", backgroundColor: "#94bcd5", color: "#fff" }}>Fecha Toma</th>
                                <th style={{ border: "1px solid #ccc", padding: "2px", backgroundColor: "#94bcd5", color: "#fff" }}>usuario</th>
                                <th style={{ border: "1px solid #ccc", padding: "2px", backgroundColor: "#0079c7", color: "#fff" }}>Envío</th>
                                <th style={{ border: "1px solid #ccc", padding: "2px", backgroundColor: "#0079c7", color: "#fff" }}>Fecha Envío</th>
                                <th style={{ border: "1px solid #ccc", padding: "2px", backgroundColor: "#0079c7", color: "#fff" }}>Usuario Envío</th>
                                <th style={{ border: "1px solid #ccc", padding: "2px", backgroundColor: "#46afe5d4", color: "#fff" }}>Recepción</th>
                                <th style={{ border: "1px solid #ccc", padding: "2px", backgroundColor: "#46afe5d4", color: "#fff" }}>Fecha Recepción</th>
                                <th style={{ border: "1px solid #ccc", padding: "2px", backgroundColor: "#46afe5d4", color: "#fff" }}>Usuario Recepción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rowData.arrayCurves.map((item, idx) => (
                                <tr key={idx} style={{ textAlign: "center" }}>
                                    <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.num_samplings ?? 0}</td>
                                    <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.user_flebo === null ? <i className='fa fa-times text-danger f-16' ></i> : <i className='fa fa-check txt-success f-18' ></i> ?? "N/A"}</td>
                                    <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.init_time_flebo ?? "---"}</td>
                                    <td style={{ border: "1px solid #ccc", padding: "2px" }}> {item?.user_flebo ?? "---"}  </td>
                                    <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.user_process2 === null ? <i className='fa fa-times text-danger f-16' ></i> : <i className='fa fa-check txt-success f-18' ></i> ?? "N/A"}</td>
                                    <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.init_time_procces2 ?? "---"}</td>
                                    <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.user_process2 ?? "---"}</td>
                                    <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.user_process3 === null ? <i className='fa fa-times text-danger f-16' ></i> : <i className='fa fa-check txt-success f-18' ></i> ?? "N/A"}</td>
                                    <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.init_time_procces3 ?? "---"}</td>
                                    <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.user_process3 ?? "---"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }
        return null;
    };

    // Iconos por campo para escaneo rápido
    const FIELD_ICONS = {
        tipoIngreso: 'fa-id-card',
        fechaIngreso: 'fa-calendar-check',
        sucursal: 'fa-building',
        nombrePaciente: 'fa-user-circle',
        fechaPromesa: 'fa-clock',
        recepcion: 'fa-user-md',
    };

    const patientCardStyles = {
        card: {
            border: 'none',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(13, 59, 89, 0.08)',
            overflow: 'hidden',
            transition: 'box-shadow 0.25s ease, transform 0.2s ease',
            borderLeft: '4px solid transparent',
            background: '#fff',
        },
        cardHover: {
            borderLeftColor: '#1d5b83',
            boxShadow: '0 8px 28px rgba(13, 59, 89, 0.12)',
        },
        stepWrapper: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '10px',
            padding: '18px 24px',
            background: 'linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)',
            borderBottom: '1px solid #e2e8f0',
        },
        stepNum: {
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            background: 'linear-gradient(145deg, #0d3b59 0%, #1d5b83 100%)',
            color: '#fff',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            fontWeight: 700,
            boxShadow: '0 2px 8px rgba(29, 91, 131, 0.35)',
        },
        stepNumInactive: {
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            backgroundColor: '#e2e8f0',
            color: '#94a3b8',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            fontWeight: 600,
        },
        stepLabel: { fontWeight: 600, color: '#1d5b83', fontSize: '14px' },
        stepLabelInactive: { fontWeight: 500, color: '#94a3b8', fontSize: '14px' },
        stepConnector: { width: '20px', height: '2px', backgroundColor: '#cbd5e1', borderRadius: 1 },
        body: { padding: '24px 28px' },
        avatarWrap: {
            position: 'relative',
            flexShrink: 0,
        },
        avatar: {
            width: '72px',
            height: '72px',
            borderRadius: '50%',
            objectFit: 'cover',
            border: '4px solid #e0f2fe',
            boxShadow: '0 4px 12px rgba(13, 59, 89, 0.15)',
        },
        avatarRing: {
            position: 'absolute',
            inset: -4,
            borderRadius: '50%',
            border: '2px solid rgba(29, 91, 131, 0.2)',
            pointerEvents: 'none',
        },
        fieldGroup: {
            marginBottom: '20px',
            paddingBottom: '20px',
            borderBottom: '1px solid #f1f5f9',
        },
        fieldGroupLast: { marginBottom: 0, paddingBottom: 0, borderBottom: 'none' },
        label: {
            fontSize: '11px',
            fontWeight: 600,
            color: '#64748b',
            marginBottom: '6px',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
        },
        labelIcon: { color: '#1d5b83', opacity: 0.85, width: '14px', textAlign: 'center' },
        value: { fontSize: '13px', fontWeight: 500, color: '#0f172a', lineHeight: 1.4 },
        valueBold: { fontSize: '14px', fontWeight: 600, color: '#0f172a', lineHeight: 1.35 },
        subValue: { fontSize: '12px', color: '#64748b', marginTop: '2px' },
        badgeDate: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '8px 14px',
            borderRadius: '999px',
            fontSize: '13px',
            fontWeight: 600,
            backgroundColor: '#fff7ed',
            color: '#c2410c',
            border: '1px solid #ffedd5',
        },
        badgeDateEmpty: {
            display: 'inline-flex',
            alignItems: 'center',
            padding: '8px 14px',
            borderRadius: '999px',
            fontSize: '13px',
            fontWeight: 500,
            backgroundColor: '#f8fafc',
            color: '#94a3b8',
            border: '1px dashed #e2e8f0',
        },
        badgeVigente: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 16px',
            borderRadius: '999px',
            fontSize: '13px',
            fontWeight: 700,
            backgroundColor: '#88e7a9',
            color: '#166534',
            border: '1px solid #bbf7d0',
            boxShadow: '0 1px 2px rgba(22, 101, 52, 0.08)',
        },
        badgeCancelado: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 16px',
            borderRadius: '999px',
            fontSize: '13px',
            fontWeight: 700,
            backgroundColor: '#fee2e2',
            color: '#b91c1c',
            border: '1px solid #fecaca',
            boxShadow: '0 1px 2px rgba(185, 28, 28, 0.08)',
        },
        nimId: { fontSize: '13px', fontWeight: 700, color: '#ea580c', marginTop: '4px', letterSpacing: '0.02em' },
        heroBlock: {
            padding: '16px 20px',
            borderRadius: '12px',
            background: '#3b82f617',
            border: '1px solid #bae6fd',
            marginBottom: '24px',
        },
        emptyState: {
            textAlign: 'center',
            padding: '56px 32px',
            background: 'linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)',
            borderRadius: '16px',
            margin: '20px 0',
            border: '2px dashed #e2e8f0',
        },
        emptyIcon: {
            width: '80px',
            height: '80px',
            margin: '0 auto 20px',
            borderRadius: '50%',
            background: 'linear-gradient(145deg, #e0f2fe 0%, #bae6fd 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#0d3b59',
            fontSize: '36px',
        },
        emptyTitle: { fontSize: '15px', fontWeight: 600, color: '#475569', marginBottom: '8px' },
        emptyText: { fontSize: '14px', color: '#64748b', fontWeight: 500, maxWidth: '320px', margin: '0 auto' },
    };





    // * STEPS REPORT LOG NIM
    const steps = [
        {
            label: 'Datos del paciente', content: <Col sm="12" className=' pl-0 pr-0' >
                {
                    dataPatient.length === 0 && <div className="text-center">
                        <img
                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                            style={{ width: "35%" }}
                            alt="Sin resultados"
                        />
                        <br />
                        <p className="badge badge-light-primary mt-2" style={{ fontSize: "14px" }}>
                            No se ha realizado ninguna auditoría.
                        </p>
                    </div>
                }
                {dataPatient.map((item, index) => (

                    <Col sm="12" className="pt-4 pl-0 pr-0">
                        {(!dataPatient || dataPatient.length === 0) && (
                            <div style={patientCardStyles.emptyState}>
                                <div style={patientCardStyles.emptyIcon}>
                                    <i className="fa fa-clipboard-list" aria-hidden />
                                </div>
                                <p style={patientCardStyles.emptyTitle}>Sin registros de auditoría</p>
                                <p style={patientCardStyles.emptyText}>
                                    No se ha realizado ninguna auditoría para esta orden. Los datos del paciente aparecerán aquí una vez generado el reporte.
                                </p>
                            </div>
                        )}
                        {(dataPatient || []).map((item, index) => {
                            const hasAdmision = item?.admision_date && item.admision_date !== '—';
                            const hasPromesa = item?.study_delivery && item.study_delivery !== '—';
                            const isVigente = item?.id_status !== 20;
                            return (
                                <Card
                                    key={index}
                                    className="mb-4 patient-detail-card"
                                    style={patientCardStyles.card}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.borderLeftColor = '#1d5b83';
                                        e.currentTarget.style.boxShadow = '0 8px 28px rgba(13, 59, 89, 0.12)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.borderLeftColor = 'transparent';
                                        e.currentTarget.style.boxShadow = '0 4px 20px rgba(13, 59, 89, 0.08)';
                                    }}
                                >
                                    <CardBody className='pt-2' style={patientCardStyles.body}>
                                        <Row className="align-items-start">
                                            <Col xs="12" md="auto" className="mb-4 mb-md-0 text-center text-md-left">
                                                <div style={patientCardStyles.avatarWrap}>
                                                    <img
                                                        src={
                                                            item.gender === 2
                                                                ? require("../../../assets/images/user/hombre.png")
                                                                : item.gender === 1
                                                                    ? require("../../../assets/images/user/mujer.png")
                                                                    : require("../../../assets/images/user/user.png")
                                                        }
                                                        alt="Paciente"
                                                        style={patientCardStyles.avatar}
                                                    />
                                                    <span style={patientCardStyles.avatarRing} aria-hidden />
                                                </div>
                                            </Col>
                                            <Col xs="12" md className="pl-md-4">
                                                <div style={patientCardStyles.heroBlock}>
                                                    <div style={{ ...patientCardStyles.label, marginBottom: '8px' }}>
                                                        Nombre del paciente
                                                    </div>
                                                    <div style={patientCardStyles.valueBold}>{item?.name_patient ?? '—'}</div>
                                                    {item?.nim ? <div style={patientCardStyles.nimId}>{item.nim}</div> : null}
                                                    <span
                                                        style={isVigente ? patientCardStyles.badgeVigente : patientCardStyles.badgeCancelado}
                                                        className="mt-3 d-inline-block"
                                                    >
                                                        {isVigente ? (
                                                            <><i className="fa fa-check-circle" style={{ fontSize: '14px' }} /> Vigente</>
                                                        ) : (
                                                            <><i className="fa fa-times-circle" style={{ fontSize: '14px' }} /> Cancelado</>
                                                        )}
                                                    </span>
                                                </div>
                                                <Row>
                                                    <Col sm="6" lg="4">
                                                        <div style={patientCardStyles.fieldGroup}>
                                                            <div style={patientCardStyles.label}>
                                                                <i className="fa fa-id-card f-16" style={patientCardStyles.labelIcon} />
                                                                Tipo de Ingreso
                                                            </div>
                                                            <div style={patientCardStyles.value}>{item?.income_type ?? '—'}</div>
                                                            {item?.company_name ? (
                                                                <div style={patientCardStyles.subValue}>{item.company_name}</div>
                                                            ) : null}
                                                        </div>
                                                    </Col>
                                                    <Col sm="6" lg="4">
                                                        <div style={patientCardStyles.fieldGroup}>
                                                            <div style={patientCardStyles.label}>
                                                                <i className="pi pi-calendar" style={patientCardStyles.labelIcon} />
                                                                Fecha de ingreso
                                                            </div>
                                                            <span style={hasAdmision ? patientCardStyles.badgeDate : patientCardStyles.badgeDateEmpty}>
                                                                {hasAdmision ? <i className="fa fa-calendar f-16" style={{ fontSize: '11px' }} /> : null}
                                                                {item?.admision_date ?? '—'}
                                                            </span>
                                                        </div>
                                                    </Col>
                                                    <Col sm="6" lg="4">
                                                        <div style={patientCardStyles.fieldGroup}>
                                                            <div style={patientCardStyles.label}>
                                                                <i className="fa fa-building f-16" style={patientCardStyles.labelIcon} />
                                                                Sucursal
                                                            </div>
                                                            <div style={patientCardStyles.value}>{item?.name_branch ?? '—'}</div>
                                                        </div>
                                                    </Col>
                                                    <Col sm="6" lg="4">
                                                        <div style={{ ...patientCardStyles.fieldGroup, ...patientCardStyles.fieldGroupLast }}>
                                                            <div style={patientCardStyles.label}>
                                                                <i className="pi pi-clock" style={patientCardStyles.labelIcon} />
                                                                Fecha promesa
                                                            </div>
                                                            <span style={hasPromesa ? patientCardStyles.badgeDate : patientCardStyles.badgeDateEmpty}>
                                                                {hasPromesa ? <i className="fa fa-clock f-16" style={{ fontSize: '11px' }} /> : null}
                                                                {item?.study_delivery ?? '—'}
                                                            </span>
                                                        </div>
                                                    </Col>
                                                    <Col sm="6" lg="4">
                                                        <div style={{ ...patientCardStyles.fieldGroup, ...patientCardStyles.fieldGroupLast }}>
                                                            <div style={patientCardStyles.label}>
                                                                <i className="fa fa-user-md f-16" style={patientCardStyles.labelIcon} />
                                                                Recepción
                                                            </div>
                                                            <div style={patientCardStyles.value}>{item?.name_user ?? '—'}</div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            );
                        })}
                    </Col>
                ))}
            </Col>
        },
        enable_tracking_toma === 'True' && {
            label: 'Trazabilidad de la muestra', content: <div>
                <ul className="list-group d-flex flex-row justify-content-left p-0" style={{ width: '100%', gap: '4px' }}>
                    <li
                        style={{
                            fontSize: "10px",
                            padding: "4px 6px",
                            width: "100px",
                            whiteSpace: "nowrap"
                        }}
                        className="list-group-item list-group-item-success rounded text-center font-weight-bold"
                    >
                        Con muestra
                    </li>
                    <li
                        style={{
                            fontSize: "10px",
                            padding: "4px 6px",
                            width: "100px",
                            whiteSpace: "nowrap"
                        }}
                        className="list-group-item list-group-item-primary rounded text-center font-weight-bold"
                    >
                        Remitida
                    </li>
                    <li
                        style={{
                            fontSize: "10px",
                            padding: "4px 6px",
                            width: "100px",
                            backgroundColor: '#ff8f00a6',
                            whiteSpace: "nowrap"
                        }}
                        className="list-group-item rounded text-center font-weight-bold"
                    >
                        Sin muestra
                    </li>
                </ul>

                <DataTable
                    value={dataTraceability}
                    className="data-table data-table-centered"
                    emptyMessage={
                        <div className="text-center">
                            <img
                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                style={{ width: "135%" }}
                                alt="Sin resultados"
                            />
                            <br />
                            <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                Sin Información de trazabilidad.
                            </p>
                        </div>
                    }
                    style={{ fontSize: "8px" }}
                    scrollable
                    expandedRows={expandedRows}
                    onRowToggle={(e) => setExpandedRows(e.data)}
                    rowExpansionTemplate={rowExpansionTemplate}
                >
                    <Column
                        expander={(rowData) => {
                            return rowData.type === 'profile' || rowData.is_curve === true;
                        }}
                        headerStyle={{
                            backgroundColor: "#1d5b83",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "5px",
                            padding: "2px 4px"
                        }}
                        style={{
                            fontSize: "5px",
                            textAlign: "center",
                            width: "10%",
                            maxWidth: "50px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                        }}
                    />
                    <Column
                        field="name"
                        header="Estudio"
                        body={(rowData) => {
                            return rowData.type === 'exam' ? rowData.name : rowData.profile_name;
                        }}
                        headerStyle={{
                            backgroundColor: "#1d5b83",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "2px 4px"
                        }}
                        style={{
                            fontSize: "10px",
                            textAlign: "center",
                            width: "10%",
                        }}
                    />
                    <Column
                        field="is_toma"
                        header="Toma de muestra"
                        body={(rowData) => (rowData.is_curve ? "" : rowData.type === 'profile' ? "" : (rowData.is_toma ? <i className='fa fa-check txt-success f-18' ></i> : rowData.check_forwarded ? "Remitida" : <i className='fa fa-times text-danger f-16' ></i>))}
                        headerStyle={{
                            backgroundColor: "#94bcd5",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "2px 4px"
                        }}
                        style={{
                            fontSize: "10px",
                            textAlign: "center",
                            width: "10%",
                        }}
                    />
                    <Column
                        field="init_time"
                        header="Fecha Toma"
                        body={(rowData) => (rowData.is_curve ? "" : rowData.type === 'profile' ? "" : (rowData.traceabilitSampling && rowData.traceabilitSampling.length > 0 ? rowData.traceabilitSampling[0].init_time : rowData.check_forwarded ? "N/A" : "Sin Fecha"))}
                        headerStyle={{
                            backgroundColor: "#94bcd5",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "2px 4px"
                        }}
                        style={{
                            fontSize: "10px",
                            textAlign: "center",
                            width: "10%",
                        }}
                    />
                    <Column
                        field="flebo"
                        header="Usuario"
                        body={(rowData) => (rowData.is_curve ? "" : rowData.type === 'profile' ? "" : (rowData.traceabilitSampling && rowData.traceabilitSampling.length > 0 ? rowData.traceabilitSampling[0].flebo : rowData.check_forwarded ? "N/A" : "Sin Usuario"))}
                        headerStyle={{
                            backgroundColor: "#94bcd5",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "2px 4px"
                        }}
                        style={{
                            fontSize: "10px",
                            textAlign: "center",
                            width: "10%",
                        }}
                    />
                    <Column
                        field="is_send1"
                        header="Envio"
                        body={(rowData) => (rowData.is_curve ? "" : rowData.type === 'profile' ? "" : (rowData.is_send1 ? <i className='fa fa-check txt-success f-18' ></i> : rowData.traceabilitSend.some(send => send.user_process2) ? (
                            <i className='fa fa-check txt-success f-18'></i>
                        ) : (
                            <i className='fa fa-times text-danger f-16'></i>
                        )))} headerStyle={{
                            backgroundColor: "#0079c7",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "2px 4px"
                        }}
                        style={{
                            fontSize: "10px",
                            textAlign: "center",
                            width: "10%",
                        }}
                    />
                    <Column
                        field="init_time_procces2"
                        header="Fecha de Envio"
                        body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                            ? row.traceabilitSend[row.traceabilitSend.length - 1].init_time_procces2
                            : ""}
                        headerStyle={{
                            backgroundColor: "#0079c7",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "2px 4px"
                        }}
                        style={{
                            fontSize: "10px",
                            textAlign: "center",
                            width: "10%",
                        }}
                    />
                    <Column
                        field="user_process2"
                        header="Usuario de Envio"
                        body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                            ? row.traceabilitSend[row.traceabilitSend.length - 1].user_process2
                            : ""}
                        headerStyle={{
                            backgroundColor: "#0079c7",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "2px 4px"
                        }}
                        style={{
                            fontSize: "10px",
                            textAlign: "center",
                            width: "10%",
                        }}
                    />
                    <Column
                        field="is_send2"
                        header="Recepción"
                        body={(rowData) => (rowData.is_curve ? "" : rowData.type === 'profile' ? "" : (rowData.is_send2 ? <i className='fa fa-check txt-success f-18' ></i> : rowData.traceabilitSend.some(send => send.user_process3) ? (
                            <i className='fa fa-check txt-success f-18'></i>
                        ) : (
                            <i className='fa fa-times text-danger f-16'></i>
                        )))} headerStyle={{
                            backgroundColor: "#46afe5d4",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "2px 4px"
                        }}
                        style={{
                            fontSize: "10px",
                            textAlign: "center",
                            width: "10%",
                        }}
                    />
                    <Column
                        field="init_time_procces3"
                        header="Fecha Recepción"
                        body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                            ? row.traceabilitSend[row.traceabilitSend.length - 1].init_time_procces3
                            : ""}
                        headerStyle={{
                            backgroundColor: "#46afe5d4",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "2px 4px"
                        }}
                        style={{
                            fontSize: "10px",
                            textAlign: "center",
                            width: "10%",
                        }}
                    />
                    <Column
                        field="user_process3"
                        header="Usuario de Recepción"
                        body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                            ? row.traceabilitSend[row.traceabilitSend.length - 1].user_process3
                            : ""}
                        headerStyle={{
                            backgroundColor: "#46afe5d4",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "2px 4px"
                        }}
                        style={{
                            fontSize: "10px",
                            textAlign: "center",
                            width: "10%",
                        }}
                    />
                </DataTable>   </div>
        },

        {
            label: 'Información General', content: <DataTable
                className="data-table"
                value={dataReport}
                paginator
                loading={loadingReport}
                rows={10}
                rowsPerPageOptions={[10, 20, 30, 40, 50]}

                responsiveLayout="scroll"
                emptyMessage={
                    <div className="text-center">
                        <img
                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                            style={{ width: "30%" }}
                            alt="Sin resultados"
                        />
                        <br />
                        <p className="badge badge-light-primary mt-2" style={{ fontSize: "14px" }}>
                            No se ha realizado ninguna auditoría.
                        </p>
                    </div>
                }

            >
                <Column
                    header="#"
                    body={(rowData, { rowIndex }) => rowIndex + 1}
                    style={{
                        textAlign: "center",
                        fontSize: "12px",
                        width: "5%",
                    }}
                    headerStyle={{
                        backgroundColor: "#1d5b83",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "10px",
                        padding: "5px",
                    }}
                />
                <Column
                    field="created_at"
                    header="Fecha"
                    sortable
                    headerStyle={{
                        backgroundColor: "#1d5b83",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "10px",
                        padding: "5px",
                    }}
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "10%",
                    }}
                />

                <Column
                    field="user"
                    header="Usuario"
                    sortable
                    headerStyle={{
                        backgroundColor: "#1d5b83",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "10px",
                        padding: "5px",
                    }}
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "10%",
                    }}
                />
                <Column
                    field="full_name"
                    header="Nombre del usuario"
                    sortable
                    headerStyle={{
                        backgroundColor: "#1d5b83",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "10px",
                        padding: "5px",
                    }}
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "10%",
                    }}
                />

                <Column
                    field="action"
                    header="Acción"
                    sortable
                    headerStyle={{
                        backgroundColor: "#1d5b83",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "10px",
                        padding: "5px",
                    }}
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "10%",
                    }}
                />
            </DataTable>
        },

    ].filter(Boolean);;

    const next = () => {
        if (activeIndex < steps.length - 1) {
            setActiveIndex(activeIndex + 1);
        }
    };

    const prev = () => {
        if (activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        }
    };






    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
                <Card style={{
                    marginBottom: '15px',
                    background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                    <CardBody style={{ padding: '18px 25px' }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '15px'
                                }}>
                                    <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/laboratory-External/icon-logs.svg")} style={{ width: "60px", height: "60px" }} />
                                </div>
                                <div>
                                    <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                        Reporte de Auditoria
                                    </h4>
                                    <small style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '13px' }}>
                                        <i className="fa fa-info-circle mr-1"></i>
                                        Análisis de los registros que se realizaron en una orden de trabajo en especifico.
                                    </small>
                                </div>
                            </div>

                        </div>
                    </CardBody>
                </Card>
                {
                    // *REPORT
                }
                <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "113%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
                    <Col sm="12" className='pt-3'>
                        <Row>
                            <Col sm="2" className='p-l-0 p-r-0' style={{ textAlign: "left" }}>
                                <Card style={{
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    border: 'none',
                                    height: '100%',
                                    borderRadius: '12px'
                                }}>
                                    <CardHeader style={{
                                        background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                        color: 'white',
                                        padding: '15px',
                                        borderRadius: '12px 12px 0 0'
                                    }}>
                                        <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                            <i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
                                        </h6>
                                    </CardHeader>
                                    <CardBody style={{ padding: '20px' }}>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>Nim
                                            </Label>
                                            <Input
                                                className='form-control form-control-sm input-air-primary'
                                                name="nim"
                                                value={nim}
                                                onChange={handleInputChange}
                                                type='number'
                                            />

                                        </FormGroup>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>Barra de navegación
                                            </Label>
                                            <Button
                                                block
                                                title="Siguiente"
                                                onClick={prev}
                                                disabled={activeIndex === 0}
                                                style={{
                                                    fontSize: '12px',
                                                    padding: '6px 12px',

                                                }}
                                            >
                                                Anterior
                                            </Button>


                                        </FormGroup>
                                        <FormGroup>
                                            <Button
                                                block
                                                title="Siguiente"
                                                onClick={next}
                                                disabled={loadingExcel || activeIndex === steps.length - 1}
                                                style={{
                                                    fontSize: '12px',
                                                    padding: '6px 12px',

                                                }}
                                            >
                                                Siguiente
                                            </Button>


                                        </FormGroup>

                                        <br />
                                        <b>Acciones</b>
                                        <br /><br />
                                        <Button
                                            onClick={() => handleReport()}

                                            color="primary"
                                            block
                                            outline
                                            className="mb-3"
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                borderWidth: '2px'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            Buscar
                                        </Button>




                                        <Button
                                            color="success"
                                            onClick={() => exportToExcelConTrazabilidad(dataReport, dataTraceability)}
                                            block
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                                transition: 'all 0.3s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            title="Descargar reporte"
                                        >
                                            <i className="pi pi-file-excel"></i>&ensp;
                                            Descargar
                                        </Button>

                                    </CardBody>


                                </Card>
                            </Col>

                            <Col sm="10">
                                <Col sm="12" className=' pl-0 pr-0' >
                                    <div className="stepper-demo">
                                        <Steps model={steps} activeIndex={activeIndex} />
                                        <div className="step-content" style={{ padding: '20px', minHeight: '200px' }}>
                                            <p>{steps[activeIndex].content}</p>
                                        </div>
                                    </div>
                                </Col>


                            </Col>
                        </Row>
                    </Col>
                </Card>
            </div>
        </div>
    )
}
